import cn from 'classnames'
import { type ReactElement } from 'react'

interface ToggleProps {
  name: string
  onClick: () => void
  selected: boolean
}

export function Toggle ({ selected, onClick, name }: ToggleProps): ReactElement {
  return (
    <div className="flex justify-center items-center">
      <div
        className={
          cn(
            'relative rounded-full w-12 h-5 transition duration-200 ease-linear',
            selected ? 'bg-emerald-400' : 'bg-gray-400'
          )
        }
      >
        <label
          htmlFor={name}
          className={
            cn(
              'absolute left-0 bg-white border-2 mb-2 w-6 h-5 rounded-full',
              'transition transform duration-100 ease-linear cursor-pointer',
              selected ? 'translate-x-full border-emerald-400' : 'translate-x-0 border-gray-400'
            )
          }
        />
        <input
          type="checkbox"
          id={name}
          name={name}
          className="appearance-none w-full h-full active:outline-none focus:outline-none cursor-pointer"
          onClick={onClick}
        />
      </div>
    </div>
  )
}
